/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2"
import { comma } from "../../utils/number";
import { isEmpty, each } from 'lodash'
import { CardHeader, CardTitle, CardUnit } from "../ContentLayout";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import { getYearRange } from "../../utils/date";
import { getFinancesStatistics } from "../../utils/financesStatistics";
import Select from "../Select";

const SalaryBarChart = (props) => {
  const {
    title = "급여내역"
  } = props
  const [data, setData] = useState(null)
  const [options, setOptions] = useState(null)
  const [isLoading, setIsLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(`${new Date().getFullYear()}`)
  const [params, setParams] = useState({
    groupBy: "month",
    startAt: `${new Date().getFullYear()}-01-01`,
    endAt: `${new Date().getFullYear()}-12-31`,
  })

  useEffect(() => {
    submit()
  }, [params])

  const submit = async () => {
    setIsLoading(true)

    const {
      salaryHistories
    } = await getFinancesStatistics(params)

    if (isEmpty(salaryHistories)) {
      setData({})
      setIsLoading(false)
      return
    }

    const salaryTotal = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]

    each(salaryTotal, (salary, idx) => {
      const month = idx + 1
      const targetMonth = salaryHistories.find(h => h.month === month)
      if (targetMonth) {
        salaryTotal[idx] = targetMonth.paymentByDifference / 1000
      }
    })

    // each(salaryHistories, (history) => {
    //   salaryTotal.push(Math.round(history.paymentByDifference / 1000))
    // })

    setData({
      labels: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      datasets: [
        {
          yAxesID: 'A',
          label: '급여',
          backgroundColor: '#5C6DFF',
          borderRadius: 5,
          data: salaryTotal,
        },
      ],
    })


    setOptions({
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return tooltipItem[0].xLabel
          },
          label: function({ datasetIndex, index, label: totalLabel }, data) {
            const target = data.datasets[datasetIndex]
            return `${target.label} : ${comma(target.data[index])}천원`
          }
        }
      },
      isStacked: true,
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            display: true,
            gridLines: {
              color: 'transparent',
              zeroLineColor: 'transparent'
            },
          },
        ],
        yAxes: [
          {
            id: 'A',
            type: 'linear',
            position: 'left',
            ticks: {
              callback: function(value, index, values) {
                return `${comma(value)}`
              },
            },
          },
        ],
      },
      plugins: {
        datalabels: {
          display: false
        },
      },
    })
    setIsLoading(false)
  }

  const handleOnChangeYear = (e) => {
    const { value } = e.target
    setSelectedYear(value)
    setParams({
      ...params,
      startAt: `${value}-01-01`,
      endAt: `${value}-12-31`,
    })
  }

  return <div className="sales-chart">
    {isLoading ?
      <Loading color={"#5C6DFF"} /> :
      <>
        <CardHeader className="border-bottom-none">
          <CardTitle>
            {title}
          </CardTitle>
          <CardUnit
            style={{
              width: '92px'
            }}
          >
            <Select value={selectedYear} onChange={handleOnChangeYear} list={getYearRange()}></Select>
          </CardUnit>
        </CardHeader>
        <div className="seles-chart-box pt-15" >
          {/* <span className="chart-unit">단위 : 천원</span> */}
          {
            isEmpty(data) ? <NoData /> : <Bar
              data={data}
              options={options}
              height={120}
            />
          }
        </div>
      </>}
  </div>
}

export default SalaryBarChart